import styled from 'styled-components';

type Props = {
    width?: string;
}

export const ContainerInput = styled.div<Props>`
    width: ${props => props.width || '100%'};
    display: inline-block;
    margin-bottom: 1.25rem;
    
    .contentInput {
        display: flex;
        width: 100%;
        position: relative;
        align-items: center;

        button {
            background: transparent;
            position: absolute;
            border: none;
            right: 12px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0.25rem;
            transition: color 0.2s ease-in-out;

            svg {
                color: #6b7280;
                transition: color 0.2s ease-in-out;
            }

            &:hover svg {
                color: #254d6b;
            }
        }
    }
`;

export const Input = styled.input<Props>`
    width: 100%;
    height: 44px;
    padding: 0.75rem 1rem;
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    font-weight: 400;
    color: #1f2937;
    background-color: #ffffff;
    border: 1.5px solid #e5e7eb;
    border-radius: 0.5rem;
    outline: none;
    transition: all 0.2s ease-in-out;

    &::placeholder {
        color: #9ca3af;
    }

    &:hover:not(:disabled) {
        border-color: #d1d5db;
    }

    &:focus {
        border-color: #254d6b;
        box-shadow: 0 0 0 3px rgba(37, 77, 107, 0.1);
    }

    &:disabled {
        background-color: #f3f4f6;
        color: #9ca3af;
        cursor: not-allowed;
    }

    &:invalid {
        border-color: #e74c3c;
    }

    @media screen and (max-width: 768px) {
        height: 42px;
        font-size: 0.9375rem;
    }
`;

export const LabelInput = styled.label`
    display: block;
    font-family: 'Inter', sans-serif;
    font-size: 0.875rem; /* 14px */
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.5rem;
    letter-spacing: 0.01em;
`;